<div class="hb-container hb-container--width-lg">
  <h1 class="hb-h1 hb-text--3xl hb-avstand--avsnitt">Statistikkbanken</h1>
  <div class="hb-grid hb-mb--xl">
    <div class="hb-cell hb-cell--10of12@md hb-cell--8of12@lg">
      <div class="hb-avstand--avsnitt">
        <p>Velkommen til Husbankens statistikkbank. Her finner du statistikk fra Husbanken som viser søknader, tilsagn og utbetalinger på boligpolitiske virkemidler.</p>
        <p>
          Hvis du opplever at tallene ikke oppdateres ved filtrering, så trykk F5 for oppfrisking av siden. Trenger du hjelp for å komme i gang? Gå til
          <a class="hb-button hb-button--link" href="hjelp/komigang">
            <span class="hb-button-text">hjelpesiden</span> </a
          >.
        </p>
      </div>
      <div class="hb-grid">
        <div class="hb-cell hb-cell--12of12 hb-cell--6of12@md">
          <stat-forsidelenke
            farge="hb-card--info"
            tittel="Startlån Ordinært"
            url="lan/startlan"
            [query]="{ laneordning: 'Ordinært startlån' }"
            kpiId="STS Utbetalt hittil i år"
          ></stat-forsidelenke>
        </div>
        <div class="hb-cell hb-cell--12of12 hb-cell--6of12@md">
          <stat-forsidelenke
            farge="hb-card--info"
            tittel="Startlån til førstegangs etablere"
            url="lan/startlan"
            [query]="{ laneordning: 'Startlån til førstegangs etablere' }"
            kpiId="STS Forsøk Utbetalt hittil i år"
          ></stat-forsidelenke>
        </div>
        <div class="hb-cell hb-cell--12of12 hb-cell--6of12@md">
          <stat-forsidelenke tittel="Bostøtte" url="bostotte" kpiId="BST Utbetalt hittil i år"></stat-forsidelenke>
        </div>
        <div class="hb-cell hb-cell--12of12 hb-cell--6of12@md">
          <stat-forsidelenke farge="hb-card--info" tittel="Lån til boligkvalitet" url="lan/boligkvalitet" kpiId="HVB Boligkvalitet hittil i år"></stat-forsidelenke>
        </div>

        <div class="hb-cell hb-cell--12of12 hb-cell--6of12@md">
          <stat-forsidelenke farge="hb-card--info" tittel="Lån til studentboliger" url="lan/studentbolig" kpiId="HVB Lån studentbolig hittil i år"></stat-forsidelenke>
        </div>
        <div class="hb-cell hb-cell--12of12 hb-cell--6of12@md">
          <stat-forsidelenke farge="hb-card--info" tittel="Lån til utleieboliger" url="lan/utleieboliglan" kpiId="HVB Lån utleiebolig hittil i år"></stat-forsidelenke>
        </div>

        <div class="hb-cell hb-cell--12of12 hb-cell--6of12@md">
          <stat-forsidelenke farge="hb-card--noytral" tittel="Investeringstilskudd" url="tilskudd/investeringstilskudd" kpiId="INV Tilsagn hittil i år"></stat-forsidelenke>
        </div>
        <div class="hb-cell hb-cell--12of12 hb-cell--6of12@md">
          <stat-forsidelenke farge="hb-card--noytral" tittel="Tilskudd utleieboliger" url="tilskudd/utleiebolig" kpiId="HVB Utleiebolig hittil i år"></stat-forsidelenke>
        </div>
        <div class="hb-cell hb-cell--12of12 hb-cell--6of12@md">
          <stat-forsidelenke farge="hb-card--noytral" tittel="Tilstandsvurdering" url="tilskudd/tilstandsvurdering" kpiId="HVB Tilstandsvurdering hittil i år"></stat-forsidelenke>
        </div>
        <div class="hb-cell hb-cell--12of12 hb-cell--6of12@md">
          <stat-forsidelenke farge="hb-card--noytral" tittel="Tilskudd til energitiltak" url="tilskudd/energitilskudd" kpiId="ENE EnergiTilskudd hittil i år"></stat-forsidelenke>
        </div>

        <div class="hb-cell hb-cell--12of12 hb-cell--6of12@md">
          <stat-forsidelenke
            farge="hb-card--noytral"
            tittel="Boligsosiale tiltak"
            url="tilskudd/kompetansetilskudd"
            kpiId="HVB Boligsosiale tiltak hittil i år"
          ></stat-forsidelenke>
        </div>
      </div>
    </div>
  </div>
</div>
